import React, { useRef } from 'react';
import cx from 'classnames';
import SequencingTile from './SequencingTile';
import { splitPoolIntoRows } from './sequencingConstants';
import { usePoolTileSize } from '../Formative/poolTileSize';

const TILE_SIZE_VAR = '--sequencing-pool-tile-size';

export default function SequencingPool({
  pool,
  placedKeys,
  revealedKeys,
  playingPoolKey,
  narrationPassActive,
  hidePool,
  pointerTarget,
  disabled,
  onPoolItemClick,
}) {
  const bandRef = useRef(null);
  usePoolTileSize(bandRef, TILE_SIZE_VAR);

  if (pool.length === 0) return null;

  const rows = splitPoolIntoRows(pool);
  const anyImageTiles = pool.some((option) => option.imageUrl);

  return (
    <div
      ref={bandRef}
      className={cx('sequencing__pool', {
        'sequencing__pool--image': anyImageTiles,
        hidden: hidePool,
      })}
    >
      {rows.map((row, rowIndex) => (
        <div className="sequencing__poolRow" data-row-count={row.length} key={`poolRow-${rowIndex}`}>
          {row.map((option) => {
            const taken = placedKeys.has(option.key);
            return (
              <SequencingTile
                key={option.key}
                option={option}
                taken={taken}
                playing={playingPoolKey === option.key}
                resting={narrationPassActive && playingPoolKey !== option.key}
                revealed={revealedKeys.has(option.key)}
                pointed={pointerTarget === option.key}
                disabled={disabled || taken || !revealedKeys.has(option.key)}
                onClick={() => onPoolItemClick(option)}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
}
